const isNumeric = value => "string" == typeof value && (!isNaN(Number(value)) && !isNaN(parseFloat(value)));

export default isNumeric;
//# sourceMappingURL=isNumeric.js.map